import { registerRootComponent } from 'expo';
//import { createRoot } from 'react-dom/client';

import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
//const root = createRoot(document.getElementById('root'));
//root.render(<App />);